<template>
  <div class="radio-img-button">
    <label :for="id">
      <input
        :id="id"
        class="radio-img-button__input"
        type="radio"
        :value="value"
        :checked="is_checked"
        :disabled="disabled"
        @input="input"
      />
      <slot name="img" :is_checked="is_checked" :is_disabled="disabled"></slot>
      <img
        v-if="is_checked"
        class="payment-methods__check"
        src="/img/icons/check-round.svg"
      />
    </label>
  </div>
</template>

<script>
  export default {
    model: {
      prop: 'model_value',
      event: 'input'
    },
    props: {
      model_value: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      id: {
        type: String,
        default: 'radio-img-button'
      },
      value: {
        type: String,
        required: true
      }
    },
    data: () => ({}),
    computed: {
      is_checked() {
        return this.value === this.model_value;
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val.target.value);
      }
    }
  };
</script>
<style lang="scss">
  .radio-img-button {
    position: relative;
    margin-right: 15px;

    &__input {
      position: absolute;
      left: -9999px;
    }
  }
</style>